import apiSlice from '../api/api.slice';
import { IPartnerData } from './partner.d';

export const partner = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPartners: builder.query<IPartnerData[], void>({
      query: () => ({
        url: '/api/v1/partner/getPartners',
        method: 'GET',
      }),
      transformResponse: (response: { partners: IPartnerData[] }) =>
        response.partners,
    }),
  }),
});

apiSlice.enhanceEndpoints({
  addTagTypes: ['partner'],
  endpoints: {
    providesTags: ['partner'],
  },
});

export const { useGetPartnersQuery } = partner;
